import React, { Component } from "react";

class Layout extends Component {

    renderVehicle = () => {
        const { vehicle, dealerSpecific } = this.props;
        const name = vehicle['@LISTING_TITLE'];
        const number_plate = vehicle['@LISTING_PLATE'];
        const spec = vehicle['@LISTING_ENGINE'];
        const miles = vehicle['@LISTING_ODOMETER_DISPLAY'];
        const info = `${vehicle['@LISTING_ENGINE']}, ${vehicle['@LISTING_FUEL_TYPE']}, ${vehicle['@LISTING_TRANSMISSION']}`;
        const src = `https://data.autoplay.co.nz/image.ashx?id=${vehicle['@LISTING_IMAGE_SEQ']}`;

        return (
            <div className="popup-form__vehicle">
                <div className="popup-form__vehicle-image" style={{backgroundImage: `url(${src})` }}></div>
                <div className="popup-form__vehicle-content">
                    <div className="popup-form__vehicle-name">{name}</div>
                    <div className="popup-form__vehicle-spec">{spec}</div>
                    <div className="popup-form__vehicle-info">
                        {miles}<br/>
                        {info}
                    </div>
                    <div className="popup-form__vehicle-plate">Number plate: {number_plate}</div>
                    {dealerSpecific ? (
                        <div>
                            <hr />
                            <div className="popup-form__vehicle-dealerSpecific">
                                {(dealerSpecific.post_title).replace("|", "-")}<br/>
                            </div>
                            {(dealerSpecific.data && dealerSpecific.data['dealership-hero'] && dealerSpecific.data['dealership-hero'].street_address) ? (
                                <div className="popup-form__vehicle-address">{dealerSpecific.data['dealership-hero'].street_address}</div>
                            ) : ''}
                        </div>
                    ) : ''}
                </div>
            </div>
        );
    }

    render() {
        const { children, title, text, hero, close, vehicle, terms, inline } = this.props;

        return (
            <div className={`popup-form__panel ${hero ? 'has-hero' : ''}`}>
                { hero ? <div className={`popup-form__hero`}><span style={{ backgroundImage: `url(${hero.src})` }}></span></div> : null }

                {!inline ?
                <div className={`popup-form__close`} onClick={close}></div> : null}

                <div className={`popup-form__body`}>
                    { title ? <h3 className={`popup-form__title`} dangerouslySetInnerHTML={{ __html: title}}/> : null }
                    { text ? <div className={`popup-form__text`} dangerouslySetInnerHTML={{__html: text}} /> : null }
                    { vehicle ? this.renderVehicle() : null }

                    <div className={`popup-form__content`}>

                        {children}
                    </div>
                    {terms ? <div className={'popup-form__terms'} dangerouslySetInnerHTML={{__html: terms}} /> : null}
                </div>

            </div>
        );
    }
}

export default Layout;
